module.exports = __webpack_public_path__ + "media/images/brands/clube_marisol-7be33a023219da33068128fcad0244d7.png";